/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RSSRemitEntityValue } from './rSSRemitEntityValue';

export class RSSRemitWrapper {
  rssLst?: Array<RSSRemitEntityValue>;
  value?: RSSRemitEntityValue;
}
